export enum MarketingShotReportTypeEnum {
    DELIVERIES = 'DELIVERIES',
    VIEWS = 'VIEWS',
    CLICKS = 'CLICKS',
    UNSUBSCRIBES = 'UNSUBSCRIBES',
    ERRORS = 'ERRORS',
    NO_VIEWS = 'NO_VIEWS',
    NO_CLICKS = 'NO_CLICKS',
}
